import apiClient from './client';
import { User } from '../../types';

interface LoginRequest {
  email: string;
  password: string;
}

interface BackendLoginRequest {
  login: string;
  password: string;
}

interface BackendLoginResponse {
  access_token: string;
  user: User;
}

interface LoginResponse {
  user: User;
  token: string;
  expiresAt: number;
}

class AuthService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    // Convert frontend format to backend format
    const backendCredentials: BackendLoginRequest = {
      login: credentials.email,
      password: credentials.password
    };
    
    const response = await apiClient.post<BackendLoginResponse>('/auth/login', backendCredentials);
    
    // Convert backend response to frontend format
    return {
      user: response.data.user,
      token: response.data.access_token,
      expiresAt: Date.now() + (24 * 60 * 60 * 1000) // 24 hours from now
    };
  }

  async validateToken(token: string): Promise<User> {
    const response = await apiClient.get<{ user: User }>('/auth/validate', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.user;
  }

  async logout(token: string): Promise<void> {
    await apiClient.post('/auth/logout', null, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  async checkSessionExpiry(token: string): Promise<{ willExpire: boolean; expiresAt: number }> {
    const response = await apiClient.get<{ willExpire: boolean; expiresAt: number }>('/auth/session-status', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
}

export const authService = new AuthService();
export type { LoginRequest, LoginResponse };